const backendOrigin = 'https://admin.kgkrealty.com';
const useProxy = process.env.REACT_APP_USE_API_PROXY === 'true';
const apiOrigin = useProxy ? window.location.origin : backendOrigin;

// Absolute URLs also support components that construct URL objects.
export const WORDPRESS_API_BASE_URL = `${apiOrigin}/wp-json`;
export const CONFIG_API_BASE_URL = useProxy
  ? `${WORDPRESS_API_BASE_URL}/custom/v1`
  : (process.env.REACT_APP_API_BASE_URL || `${WORDPRESS_API_BASE_URL}/custom/v1`).replace(/\/$/, '');
export const CONFIG_IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL || backendOrigin;
